import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { LANGUAGE } from "services/general";

/**
 * Segmented عربي / EN language switch (top-bar design). Clicking either segment
 * toggles the language via `changeLng` (the app supports two languages, so a
 * single toggle is enough — the inactive segment is always the "switch to" one).
 */
const LanguageToggle = ({ isDark, changeLng }) => {
  const { t } = useTranslation();
  const isAr = LANGUAGE === "ar";

  const activeClass = isDark
    ? "bg-primary text-surface"
    : "bg-surface shadow-sm text-heading";
  const inactiveClass = isDark ? "text-surface/60" : "text-text-muted";

  const segment = (label, active) => (
    <span
      className={`px-2.5 py-1.5 rounded-full text-xs transition-colors ${
        active ? `font-bold ${activeClass}` : `font-medium ${inactiveClass}`
      }`}
    >
      {label}
    </span>
  );

  return (
    <Tooltip title={t("change_language")}>
      <div
        role="button"
        tabIndex={0}
        onClick={changeLng}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            changeLng();
          }
        }}
        className={`flex items-center p-0.5 rounded-full cursor-pointer shrink-0 ${
          isDark ? "bg-surface/[0.08]" : "bg-surface-muted"
        }`}
      >
        {segment("عربي", isAr)}
        {segment("EN", !isAr)}
      </div>
    </Tooltip>
  );
};

export default LanguageToggle;
